import { BlokItem, DynamicRender, sbEditable, SBProps } from '../../../../../utils';

interface SBArticleCategoryProps {
  body?: BlokItem[];
  advancedSeo?: BlokItem[];
  parentProps?: {
    page?: string;
    slug?: string;
  };
}

export const SBArticleCategory = ({ blok }: SBProps<SBArticleCategoryProps>) => {
  const { body, advancedSeo, parentProps } = blok;

  return (
    <main {...sbEditable(blok)}>
      {advancedSeo && <DynamicRender data={advancedSeo} parentProps={parentProps} />}
      <DynamicRender data={body} parentProps={parentProps} />
    </main>
  );
};
